export function getTechFee(organization) {
    if (!organization) {
        return 0;
    }

    return organization.tech_fee || 0;
}
